import { render, staticRenderFns } from "./GruppoLavorazionePerFaseTabella.vue?vue&type=template&id=0dfbe588&scoped=true"
import script from "./GruppoLavorazionePerFaseTabella.vue?vue&type=script&lang=ts"
export * from "./GruppoLavorazionePerFaseTabella.vue?vue&type=script&lang=ts"
import style0 from "./GruppoLavorazionePerFaseTabella.vue?vue&type=style&index=0&id=0dfbe588&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfbe588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfbe588')) {
      api.createRecord('0dfbe588', component.options)
    } else {
      api.reload('0dfbe588', component.options)
    }
    module.hot.accept("./GruppoLavorazionePerFaseTabella.vue?vue&type=template&id=0dfbe588&scoped=true", function () {
      api.rerender('0dfbe588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GruppoLavorazionePerFaseTabella.vue"
export default component.exports